var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.26 16.71",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Info Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5-.16A8.5,8.5,0,1,0,17,8.34,8.51,8.51,0,0,0,8.5-.16m0,16.3a7.8,7.8,0,1,1,7.79-7.8,7.8,7.8,0,0,1-7.79,7.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78,3.76A2.48,2.48,0,0,0,6,6.22h.71A1.77,1.77,0,0,1,7.32,4.9,1.74,1.74,0,0,1,8.7,4.46,1.77,1.77,0,0,1,10.26,6a1.78,1.78,0,0,1-.88,1.74A2.47,2.47,0,0,0,8.15,9.91v.56h.7V9.91a1.78,1.78,0,0,1,.88-1.54,2.48,2.48,0,0,0-1-4.61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,11.53a.71.71,0,1,0,.71.71.71.71,0,0,0-.71-.71"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.2c504335eac79c35dec37e7715992fe6.svg";
export { ForwardRef as ReactComponent };